module.exports = __webpack_public_path__ + "media/images/icons/audio_mode_button-5acf8b423939f12afac41951759d7bd3.svg";